function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import classnames from "classnames";
var classPrefix = "tc-slider";
var Ticks = function Ticks(props) {
  var min = props.min,
    max = props.max,
    points = props.points,
    upperBound = props.upperBound,
    lowerBound = props.lowerBound;
  var range = max - min;
  var elements = points.map(function (point) {
    var _classnames;
    var offset = "".concat(Math.abs((point - min) / range) * 100, "%");
    var isActive = point <= upperBound && point >= lowerBound;
    var style = {
      left: offset
    };
    var pointsClassName = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(classPrefix, "-tick"), true), _defineProperty(_classnames, "".concat(classPrefix, "-tick-active"), isActive), _classnames));
    return /*#__PURE__*/React.createElement("span", {
      className: pointsClassName,
      style: style,
      key: point
    });
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-ticks")
  }, elements);
};
export default Ticks;